module.exports = __webpack_public_path__ + "static/img/01_03.8af58b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tips/01_03.png
// module id = NcXw
// module chunks = 1